import * as Actions from './actions/actions'
import watch from 'redux-watch';

export default class ProcessedResponseNavigator {
    constructor(settings) {
        this._settings = settings;
    }

    initialize(store) {
        this._store = store;

        let conversationBaseLocation = this._settings.stateLocations.Conversation.Base;
        let processedResponseLocation =  this._settings.stateLocations.Conversation.processedResponse;

        let watcher = watch(this._store.getState, `${conversationBaseLocation}.${processedResponseLocation}`);
        this._store.subscribe(watcher((newVal, oldVal, objectPath) => {
            return this.handleProcessedResponse(newVal, oldVal, objectPath);
        }));
    }

    handleProcessedResponse(newVal, oldVal, objectPath) {
        if(!(this.doesHandle(newVal) && this.containsNavLink(newVal))) return;

        let stateLocation = this._settings.stateLocations.AutoNav.stagedNav;

        this._store.dispatch(Actions.stageAutoNavigation(newVal.response.navUrl, stateLocation));
    }

    doesHandle(message) {
        let handles = false;
        if(message) {
            handles = (message.messageType === this._settings.messageConstants.converseRequest) ||
            (message.messageType === this._settings.messageConstants.requestUnitRequest) ||
            (message.messageType === this._settings.messageConstants.appeventRequest);
        }
        return handles;
    }

    containsNavLink(message) {
        let contains = false;
        if(message.response && message.response.navUrl) {
            contains = message.response.navUrl.UrlAddress != undefined
        }
        return contains;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/auto-nav-url/src/processed-response-watcher.js